import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  NgModule,
  Output,
  QueryList,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
// import {DomHandler} from '../dom/domhandler';
import { PrimeTemplate, SharedModule } from '../../common/shared';
import { TreeNode } from '../../common/treenode';

@Component({
  selector: '[pTreeChartNode]',
  // template: ` `,
  templateUrl: './treechartNode.html',
  styleUrls: ['./treechart.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('childState', [
      state('in', style({ opacity: 1 })),
      transition('void => *', [style({ opacity: 0 }), animate(150)]),
      transition('* => void', [animate(150, style({ opacity: 0 }))])
    ])
  ]
})
export class TreeChartNode {
  @Input() node: TreeNode;

  @Input() root: boolean;

  @Input() first: boolean;

  @Input() last: boolean;
  @Input() marginLeft = 0;
  @Input() isVerticalNode: boolean;
  chart: TreeChart;
  @Input() childCountV: number;
  constructor(@Inject(forwardRef(() => TreeChart)) chart) {
    this.chart = chart as TreeChart;
  }

  get leaf(): boolean {
    return this.node.leaf === false
      ? false
      : !(this.node.children && this.node.children.length);
    // return false;
  }

  get colspan() {
    return this.node.children && this.node.children.length
      ? this.node.children.length * 2
      : null;
  }

  onNodeClick(event: Event, node: TreeNode) {
    this.chart.onNodeClick(event, node);
  }

  toggleNode(event: Event, node: TreeNode) {
    node.expanded = !node.expanded;
    event.preventDefault();
    this.chart.onNodeExpandtoggle(event, node);
  }

  isSelected() {
    return this.chart.isSelected(this.node);
  }
}

@Component({
  selector: 'p-treeChart',
  template: `
    <div
      [ngStyle]="style"
      [class]="styleClass"
      [ngClass]="'ui-organizationchart ui-widget'"
    >
      <table
        class="ui-organizationchart-table"
        pTreeChartNode
        [node]="root"
        *ngIf="root"
      ></table>
    </div>
  `
})
export class TreeChart implements AfterContentInit {
  @Input() value: TreeNode[];

  @Input() style: any;

  @Input() styleClass: string;

  @Input() selectionMode: string;

  @Input() selection: any;

  @Output() selectionChange: EventEmitter<any> = new EventEmitter();

  @Output() onNodeSelect: EventEmitter<any> = new EventEmitter();

  @Output() onNodeUnselect: EventEmitter<any> = new EventEmitter();

  @Output() onNodetoggle: EventEmitter<any> = new EventEmitter();

  @ContentChildren(PrimeTemplate) templates: QueryList<any>;

  public templateMap: any;

  constructor(public el: ElementRef) {}

  get root(): TreeNode {
    return this.value && this.value.length ? this.value[0] : null;
  }

  ngAfterContentInit() {
    if (this.templates.length) {
      this.templateMap = {};
    }

    this.templates.forEach((item) => {
      this.templateMap[item.getType()] = item.template;
    });
  }

  getTemplateForNode(node: TreeNode): TemplateRef<any> {
    if (this.templateMap)
      return node.type
        ? this.templateMap[node.type]
        : this.templateMap['default'];
    else return null;
  }

  onNodeClick(event: Event, node: TreeNode) {
    let eventTarget = <Element>event.target;

    if (
      eventTarget.className &&
      (eventTarget.className.indexOf('ui-node-toggler') !== -1 ||
        eventTarget.className.indexOf('ui-node-toggler-icon') !== -1)
    ) {
      return;
    } else if (this.selectionMode) {
      if (node.selectable === false) {
        return;
      }

      let index = this.findIndexInSelection(node);
      let selected = index >= 0;

      if (this.selectionMode === 'single') {
        if (selected) {
          this.selection = null;
          this.onNodeUnselect.emit({ originalEvent: event, node: node });
        } else {
          this.selection = node;
          this.onNodeSelect.emit({ originalEvent: event, node: node });
        }
      } else if (this.selectionMode === 'multiple') {
        if (selected) {
          this.selection = this.selection.filter((val, i) => i != index);
          this.onNodeUnselect.emit({ originalEvent: event, node: node });
        } else {
          this.selection = [...(this.selection || []), node];
          this.onNodeSelect.emit({ originalEvent: event, node: node });
        }
      }

      this.selectionChange.emit(this.selection);
    }
  }

  findIndexInSelection(node: TreeNode) {
    let index: number = -1;

    if (this.selectionMode && this.selection) {
      if (this.selectionMode === 'single') {
        index = this.selection == node ? 0 : -1;
      } else if (this.selectionMode === 'multiple') {
        for (let i = 0; i < this.selection.length; i++) {
          if (this.selection[i] == node) {
            index = i;
            break;
          }
        }
      }
    }

    return index;
  }

  isSelected(node: TreeNode) {
    return this.findIndexInSelection(node) != -1;
  }

  onNodeExpandtoggle(event: Event, node: TreeNode) {
    this.onNodetoggle.emit({ originalEvent: event, node: node });
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [TreeChart, SharedModule],
  declarations: [TreeChart, TreeChartNode]
})
export class TreeChartModule {}
